import React from "react";
import Link from "gatsby-link";
import {
  Head,
  H1,
  H2,
  H3,
  H4,
  Text,
  Card,
  CardLayout,
  Article,
  Main,
  PageHeader,
  PageContent,
  PageSection,
  PrimaryButton
} from "components";
import { Box } from "rebass";

class NotFoundPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: ""
    };
  }
  componentDidMount() {
    setTimeout(() => {
      if (document.documentElement.lang !== "") {
        this.setState({ lang: document.documentElement.lang });
      }
    }, 300);
  }
  render() {
    return (
      <div style={this.props.transition ? this.props.transition.style : { opacity: 0 }}>
        <Head
          source={{
            meta_title: [
              {
                text: "404"
              }
            ],
            meta_description: [
              {
                text: ""
              }
            ],
            social_sharing_image: {
              url: ""
            }
          }}
        />
        <Main>
          {this.state.lang !== "" && (
            <Box>
              <PageHeader
                title={
                  this.state.lang === "en-us"
                    ? "You may have tried to access a page that doesn't exist yet, or is not available in your language."
                    : this.state.lang === "es-mx"
                      ? "Es posible que haya intentado acceder a una página que aún no existe o que no está disponible en su idioma."
                      : "قد تكون حاولت الوصول إلى صفحة غير موجودة بعد ، أو غير متوفرة باللغة المطلوبة. "
                }
                color={"404"}
              />
              <PageSection>
                <PageContent>
                  <PrimaryButton
                    is={Link}
                    to={
                      this.state.lang === "en-us"
                        ? "/"
                        : "/" + this.state.lang + "/"
                    }
                    children={
                      this.state.lang === "en-us"
                        ? "Click here to go to our homepage."
                        : this.state.lang === "es-mx"
                          ? "Haga clic aquí para regresar a nuestra página principal."
                          : "اضغط هنا للرجوع الى صفحتنا الرئيسية."
                    }
                  />
                </PageContent>
              </PageSection>
            </Box>
          )}
        </Main>
      </div>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/pages/404.js